import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import IncidentDetailMainDetailCard from '@/modules/adjusterReportModules/IncidentDetails/components/incidentDetails/incidentDetailMainDetailCard';
import useIncidentDetailsProperty from '@/modules/adjusterReportModules/IncidentDetails/pages/propertyDamageDetails/propertyDamageDetailsPage.biz';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

export const PropertyDamageShowDetails = () => {
  return (
    <MainLayout header="titleHeader" title="مشخصات حادثه" hasBottomPadding>
      <PropertyDamageShowDetailsPage />
    </MainLayout>
  );
};

const PropertyDamageShowDetailsPage = () => {
  const { incidentCardInfo, incidentCardInfoPending } =
    useIncidentDetailsProperty();
  if (incidentCardInfoPending) return <LoadingPage />;
  return (
    <Box pt={25}>
      <IncidentDetailMainDetailCard
        fileNumber={incidentCardInfo?.order_id!}
        fileType={incidentCardInfo?.file_type.const!}
        svgColor="colors.pink"
        items={incidentCardInfo?.detailCardItems ?? []}
        hasBullet={true}
        backgroundColor="pink-1"
        headerClassName={css({ borderColor: 'pink-1' })}
      />
    </Box>
  );
};
